import React from "react";
import Sidebar from "./Sidebar";

const AdminLayout = ({ children }) => {
  return (
    <div
      className="h-screen bg-gradient-to-b from-slate-50 to-white
 grid grid-rows-[1fr_auto]"
    >
      {/* ================= SCROLLABLE CONTENT ================= */}
      <main
        className="
          overflow-y-auto
          pt-0 md:pt-10 lg:pt-16 pb-24
        "
      >
        {children}
      </main>

      {/* ================= FIXED NAV ZONE (NON-SCROLL) ================= */}
      <Sidebar />
    </div>
  );
};

export default AdminLayout;
